module.exports = __webpack_public_path__ + "static/blueberry-570e57521fe4df26a900bedb613dbaf7.png";